import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ForgotPassword() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get("email") || "");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const emailOk = EMAIL_RE.test(email);
  const submit = async (e) => {
    e.preventDefault();
    if (!emailOk) { toast.error("Ingresa un correo válido con la forma nombre@dominio.cl"); return; }
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4">
      <Card className="w-full max-w-md p-6">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck className="w-12 h-12 text-primary mx-auto mb-3" />
            <h1 className="text-xl font-bold">Revisa tu correo</h1>
            <p className="text-muted-foreground text-sm mt-2">
              Si el email está registrado, enviamos un enlace para restablecer tu contraseña.
            </p>
            <Link to="/login"><Button variant="ghost" className="mt-4 gap-2"><ArrowLeft className="w-4 h-4" />Volver</Button></Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <h1 className="text-xl font-bold">Recuperar contraseña</h1>
            <p className="text-muted-foreground text-sm mt-1 mb-4">Te enviaremos un enlace de recuperación.</p>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value.trim())}
              required aria-invalid={email.length > 0 && !emailOk} className={email.length > 0 && !emailOk ? "mb-1" : "mb-4"} data-testid="forgot-email" />
            {email.length > 0 && !emailOk && (
              <p className="text-xs text-destructive mb-4" data-testid="forgot-email-error">Ingresa un correo válido con la forma nombre@dominio.cl</p>
            )}
            <Button type="submit" className="w-full" disabled={loading || !emailOk} data-testid="forgot-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enviar enlace"}
            </Button>
            <Link to="/login"><Button variant="ghost" className="w-full mt-2 gap-2"><ArrowLeft className="w-4 h-4" />Volver</Button></Link>
          </form>
        )}
      </Card>
    </div>
  );
}
